import { Box, Button, Grid, Typography } from '@mui/material'
import PopUpMenuIcon from './PopUpMenuIcon'
import { IPopUpMenu } from 'components/PopOver/PopUp'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { tid } from 'utilities/e2e/e2eUtils'

export interface EachPopUpMenuProps {
    onClickEachMenu: (menuID: string, isPopup?: boolean) => void
    menu: IPopUpMenu
    isSelect: boolean
    disabled?: boolean
}

const EachPopUpMenu = ({
    onClickEachMenu = () => {},
    menu,
    isSelect,
    disabled = false,
}: EachPopUpMenuProps) => {
    const { isLandscapeMobile } = useScreenSize()
    return (
        <Grid item md={4} xs={isLandscapeMobile ? 3 : 6}>
            <Button
                data-testid={tid(menu.name, menu.testIdPrefix)}
                disabled={disabled}
                color={isSelect ? 'primary' : 'bluegrey'}
                sx={{
                    minHeight: '90px',
                    height: '100%',
                    width: '100%',
                    fontSize: '18px',
                    marginBottom: (theme) => theme.spacing(0.25),
                    '&:hover': {
                        boxShadow: 'none',
                        backgroundColor: 'primary.dark',
                    },
                }}
                onClick={() => onClickEachMenu(menu.menuId, menu.isPopup)}
            >
                <Box
                    sx={{
                        width: '100%',
                        textAlign: 'center',
                        padding: '4px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        flexDirection: 'column',
                    }}
                >
                    {menu.icon && (
                        <PopUpMenuIcon icon={menu.icon} name={menu.name} />
                    )}
                    <Typography
                        style={{ fontSize: 16 }}
                        fontWeight={isSelect ? 'bold' : undefined}
                    >
                        {menu.name}
                    </Typography>
                </Box>
            </Button>
        </Grid>
    )
}

export default EachPopUpMenu
